import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
    },
    {
      path: '/oauth/callback',
      name: 'oauth-callback',
      component: () => import('@/views/OAuthCallback.vue'),
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/Upload.vue'),
    },
    {
      path: '/case/:id',
      name: 'case-detail',
      component: () => import('@/views/CaseDetail.vue'),
    },
    {
      path: '/favorites',
      name: 'favorites',
      component: () => import('@/views/MyFavorites.vue'),
    },
    {
      path: '/client/account',
      name: 'client-account',
      component: () => import('@/views/ClientAccount.vue'),
    },
    {
      path: '/client/uploads',
      name: 'client-uploads',
      component: () => import('@/views/ClientUploads.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFound.vue'),
    },
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router